import React from 'react';
import axios from 'axios';
import {
  LoadingOutlined,
} from '@ant-design/icons';
import config from 'react-global-configuration';

class App extends React.Component {
  _isMounted = false;

  constructor(props) {
      super(props);
      this.state = { vimage: [], loaded: false };
  }
  componentDidMount() { 
    this._isMounted = true;
    axios.get(config.get('backendURL') + 'homelayout/video/' + this.props.params.ItemData)
    .then(response => {
      //console.log((response.data)[0].img + "xxx")
      this.setState({
        vtype: (response.data)[0].img.contentType,
        videoName: (response.data)[0].meta_data.filename,
        vimage: (response.data)[0].img.data.toString()
      })
    })
    .catch(function (error) {
      console.log(error);
    })

};

componentWillUnmount() {
  this._isMounted = false;
}
 
  render() {
 //console.log(this.state.vimage)
   
      return (
      <>
        
        <div className={this.props.params.className} >
<video autostart autoPlay loop muted="muted"  src={'https://cdn.neurolage.com/retailpacx/'+sessionStorage.getItem('companybrandname')+'/'+this.state.videoName} style={{width: '100%'}}></video> 
     
 
  </div>
  </>
      )
  }
}

export default App;
